import Modules from '../provider/modules'
import apply from './apply'

import { toCamel, hasProp } from 'vessel/utils'

function extract(attrs) {
  const object = {}
  const ignore = {}

  if (attrs) {
    Object.entries(attrs).forEach(([key, value]) => {
      const module = toCamel(key)

      if (hasProp(module, Modules))
        object[module] = value
      else
        ignore[key] = value
    })
  }

  return [object, ignore]
}

export default function render(h, tag, options, children) {
  const [styles, attrs] = extract(options.attrs)
  const classes = Object.keys(apply(styles))

  options.attrs = attrs
  options.class = classes.concat(options.class || [])

  return h(tag, options, children)
}
